// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/deployment.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Metadata } from "./entity_pb.js";

/**
 * @generated from enum ai.h2o.storage.DeploymentType
 */
export const DeploymentType = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.storage.DeploymentType",
  [
    {no: 0, name: "DEPLOYMENT_TYPE_UNSPECIFIED"},
    {no: 1, name: "SINGLE_MODEL"},
    {no: 2, name: "SHADOW_TRAFFIC"},
    {no: 3, name: "SPLIT_TRAFFIC"},
  ],
);

/**
 * Represents a deployment of a model scorer.
 *
 * @generated from message ai.h2o.storage.Deployment
 */
export const Deployment = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.Deployment",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_time", kind: "message", T: Timestamp },
    { no: 4, name: "last_modified_time", kind: "message", T: Timestamp },
    { no: 5, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "deployment_environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "type", kind: "enum", T: proto3.getEnumType(DeploymentType) },
    { no: 9, name: "secondary_scorer", kind: "message", T: SecondaryScorer, repeated: true },
    { no: 10, name: "metadata", kind: "message", T: Metadata },
    { no: 11, name: "deployer_data_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "deployer_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 13, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines a secondary model that handles a fraction or a copy of the traffic.
 *
 * @generated from message ai.h2o.storage.SecondaryScorer
 */
export const SecondaryScorer = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.SecondaryScorer",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fraction", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

